/*! *********************************************************************
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import styled from 'styled-components';
import { FileField } from 'react-admin';

export default styled(FileField).attrs({
  className: (props) => (props.record.rawFile ? 'new-upload-file' : ''),
})`
  &.new-upload-file a {
    font-style: italic;
    ::before,
    ::after {
      content: ' ~ ';
    }
  }
`;
